import React from 'react';
import {
    Box,
    Grid
} from '@mui/material';
import {
    Assessment,
    People,
    TrendingUp,
    School,
} from '@mui/icons-material';
import StatCard from '../UI/StatCard';

const StatCardWrapper = ({ children }) => (
    <Grid item xs={12} sm={6} md={4}>
        {children}
    </Grid>
);


const SummaryCards = ({
    filteredData,
    participantsEnrolled,
    overallAverage,
    allProgramCodes,
    selectedTab
}) => {
    return (
        <Box sx={{ px: 3, mb: 4 }}>
            <Grid container spacing={3}>
                <StatCardWrapper>
                    <StatCard
                        title="Total Assessments"
                        value={filteredData.length}
                        icon={<Assessment />}
                        color="#0a0068"
                    />
                </StatCardWrapper>
                <StatCardWrapper>
                    <StatCard
                        title="Participants Enrolled"
                        value={participantsEnrolled}
                        icon={<People />}
                        color="#2196f3"
                    />
                </StatCardWrapper>
                <StatCardWrapper>
                    <StatCard
                        title="Average Score"
                        value={`${overallAverage}%`}
                        icon={<TrendingUp />}
                        color="#4caf50"
                    />
                </StatCardWrapper>
            </Grid>
        </Box>
    );
};

export default SummaryCards;